/**
 * Shared styles for table filters to maintain consistency
 */
export const FILTER_STYLES = {
  input: { fontSize: '12px' },
  dropdown: { fontSize: '12px' },
} as const

export const CALENDAR_STYLES = {
  calendarHeader: { fontSize: '11px' },
  weekday: { fontSize: '10px' },
  day: { fontSize: '10px' },
} as const
